/**
 * Soft-redirects de URLs viejas de reportes.
 * Una sola tabla: App.tsx las monta; los tests las inventarian.
 *
 * Páginas residuales sin ruta (`CashflowReportPage`, wrappers F2 en
 * `BlockMetricReportPages`) son cleanup opcional, no bloquean Done de producto.
 */
export interface ReportLegacyRedirect {
  path: string;
  to: string;
  setParams?: Record<string, string>;
}

export const REPORT_LEGACY_REDIRECTS: readonly ReportLegacyRedirect[] = [
  { path: 'reports/cashflow', to: '/finances', setParams: { tab: 'methods' } },
  { path: 'reports/payment-methods', to: '/finances', setParams: { tab: 'methods' } },
  { path: 'reports/plan-ranking', to: '/finances', setParams: { tab: 'plans' } },
  { path: 'reports/trend', to: '/finances', setParams: { tab: 'trend' } },
  { path: 'reports/patients', to: '/patients', setParams: { tab: 'overview' } },
  { path: 'reports/new-vs-returning', to: '/patients', setParams: { tab: 'acquisition' } },
  { path: 'pacientes/recurrencia', to: '/patients', setParams: { tab: 'retention' } },
  { path: 'pacientes/no-volvieron', to: '/patients', setParams: { tab: 'risk' } },
  { path: 'reports/recurrence', to: '/reports/conversion' },
  { path: 'reports/professionals', to: '/professionals' },
  { path: 'reports/billing-vs-revenue', to: '/subscription' },
  { path: 'reports/coofit-plan', to: '/subscription' },
  { path: 'reports/coofit-debt', to: '/subscription' },
  { path: 'reports/data-quality', to: '/operations' },
  { path: 'reports/audit', to: '/operations', setParams: { tab: 'audit' } },
];

/** Alias de catálogo que no deben volver a `REPORTS_CATALOG`. */
export const REMOVED_CATALOG_ALIASES = [
  'payment_methods',
  'recurrence',
  'coofit_plan_status',
  'coofit_debt',
] as const;

/** Keys i18n `reports.items.*` que no son canónicas (páginas residuales / bookmarks). */
export const DEPRECATED_REPORT_ITEM_IDS = ['coofit_plan_status', 'coofit_debt'] as const;

/**
 * Bookmarks de reportes `soon`: página honesta, no 500 ni link a feature inexistente.
 * Alias snake_case por si quedó un deep-link viejo.
 */
export const REPORT_COMING_SOON_PATHS = [
  'reports/ownership-profit',
  'reports/ownership_profit',
] as const;
